import React from 'react';
import { VerticalTimeline, VerticalTimelineElement } from 'react-vertical-timeline-component';
import 'react-vertical-timeline-component/style.min.css';

import ProdaptIcon from "../../assets/prodapt_logo.jpg";
import CitcoIcon from "../../assets/citco_logo.png";
import bsnl from "../../assets/bsnl.png";
import IngeniousTech from "../../assets/ingenious-tech.png";
import "./ReactiveTimeline.css";

const ReactiveTimeline = () => {
  return (
    <div className="timeline-container">
    {/* style={{ backgroundColor: '#212121', padding: '2rem' }}> */}

    {/* 1st */}

      <VerticalTimeline lineColor="#3A506B  ">
         {/* 2nd */}

        <VerticalTimelineElement
          className="vertical-timeline-element--work  custom-timeline"
           contentStyle={{
            background: 'linear-gradient(to right, #f0f4f8, #e0f7fa)',
            color: '#1e293b',
          }}
          contentArrowStyle={{ borderRight: '7px solid #EDF6F9' }}
          date="Jul 2025 - Present"
          iconStyle={{ background: '#1976d2', color: '#fff' }}
          icon={<img src={CitcoIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
        >
          <h3 className="vertical-timeline-element-title text-[#0f172a]">Software Developer</h3>
          <h4 className="vertical-timeline-element-subtitle text-[#334155] italic">CITCO</h4>
          <p className="text-base text-[#475569] leading-relaxed">Achieved nearly 85% reduction in manual health check efforts by creating a custom dashboard and shell scripts for consolidated reporting.</p>
          <p className="text-base text-[#475569] leading-relaxed">Working on core banking system (T24) development, focusing on automation and performance improvements.</p>
          <p className="text-base text-[#475569] leading-relaxed">Exploring and contributing to banking processes and business functionalities while aligning them with technical solutions.</p>
        </VerticalTimelineElement>


        <VerticalTimelineElement
          className="vertical-timeline-element--work custom-timeline"
          contentStyle={{
            background: 'linear-gradient(to right, #f0f4f8, #e0f7fa)',
            color: '#1e293b',
          }}
          contentArrowStyle={{ borderRight: '7px solid #e0f7fa' }}
          date="Dec 2023 - July 2025"
          iconStyle={{ background: '#1a237e', color: '#fff' }}
          icon={<img src={ProdaptIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }}
          />}
        >
          <h3 className="vertical-timeline-element-title text-[#0f172a]">Software Engineer</h3>
          <h4 className="vertical-timeline-element-subtitle  text-[#334155] italic">Prodapt</h4>
          <p className="text-base text-[#475569] leading-relaxed">Migrated authentication system to AWS Cognito for 20k+ users with social login and enhanced security.</p>
          <p className="text-base text-[#475569] leading-relaxed">Secured user data via encryption and dynamic masking without affecting user experience.</p>
          <p className="text-base text-[#475569] leading-relaxed">Integrated Razorpay to replace manual payments, automating verification and improving user experience.</p>
        </VerticalTimelineElement>

          {/* 2nd */}

        <VerticalTimelineElement
          className="vertical-timeline-element--work  custom-timeline"
           contentStyle={{
            background: 'linear-gradient(to right, #f0f4f8, #e0f7fa)',
            color: '#1e293b',
          }}
          contentArrowStyle={{ borderRight: '7px solid #EDF6F9' }}
          date="Jul 2023 - Dec 2023"
          iconStyle={{ background: '#1976d2', color: '#fff' }}
          icon={<img src={ProdaptIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
        >
          <h3 className="vertical-timeline-element-title text-[#0f172a]">Software Engineer Trainee</h3>
          <h4 className="vertical-timeline-element-subtitle text-[#334155] italic">Prodapt</h4>
          <p className="text-base text-[#475569] leading-relaxed">Built responsive React UIs with role-based post-login views for admins and users.</p>
          <p className="text-base text-[#475569] leading-relaxed">Migrated to microservices, improving efficiency by 40% and reducing downtime by 35%.</p>
          <p className="text-base text-[#475569] leading-relaxed">Automated account suspension and invoice generation, cutting manual work by 25%.</p>
        </VerticalTimelineElement>

        {/* 3rd */}

        <VerticalTimelineElement
          className="vertical-timeline-element--education  custom-timeline"
          contentStyle={{
            background: 'linear-gradient(to right, #f0f4f8, #e0f7fa)',
            color: '#000',
          }}
          contentArrowStyle={{ borderRight: '7px solid #e0f7fa' }}
          date="Nov 2021 - May 2022"
          iconStyle={{ background: '#64b5f6', color: '#fff' }}
          icon={<img src={IngeniousTech} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
        >
          <h3 className="vertical-timeline-element-title text-[#0f172a]">Cloud Intern</h3>
          <h4 className="vertical-timeline-element-subtitle text-[#334155] italic">Ingenious-tech</h4>
          <p  className="text-base text-[#475569] leading-relaxed">Implemented role-based authentication using AWS Cognito for secure access control.</p>
          <p className="text-base text-[#475569] leading-relaxed">Migrated workloads across cloud using AWS Application Migration with minimal downtime.</p>
          <p className="text-base text-[#475569] leading-relaxed">Deployed scalable infrastructure using EC2, S3, and RDS on AWS.</p>
        </VerticalTimelineElement>

          {/* 4th */}

        <VerticalTimelineElement
          className="vertical-timeline-element--education  custom-timeline"
          contentStyle={{
            background: 'linear-gradient(to right, #f0f4f8, #e0f7fa)',
            color: '#000',
          }}
          contentArrowStyle={{ borderRight: '7px solid #EDF6F9' }}
          date="May 2021 - June 2021"
          iconStyle={{ background: '#64b5f6', color: '#fff' }}
          icon={<img src={bsnl} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
        >
          <h3 className="vertical-timeline-element-title text-[#0f172a]">Internship on advance IP Networking</h3>
          <h4 className="vertical-timeline-element-subtitle text-[#334155] italic">BSNL</h4>
          <p className="text-base text-[#475569] leading-relaxed">Engineered and simulated MAN, WAN, and CAN topologies using Cisco Packet Tracer.</p>
          <p className="text-base text-[#475569] leading-relaxed">Analyzed and applied real-world use cases of routers, switches, and networking protocols.</p>
          <p className="text-base text-[#475569] leading-relaxed">Designed a scalable Campus Area Network architecture tailored for university-level deployment.</p>
        </VerticalTimelineElement>

        {/* <VerticalTimelineElement
          iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
          icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
        /> */}
      </VerticalTimeline>
    </div>
  );
};

export default ReactiveTimeline;



// import React from 'react'
// import { VerticalTimeline, VerticalTimelineElement }  from 'react-vertical-timeline-component';
// import 'react-vertical-timeline-component/style.min.css';
// import WorkIcon from "../../assets/myphoto.jpg"; 

// const ReactiveTimeline = () => {
//   return (
//     <div>
//       <VerticalTimeline>
//   <VerticalTimelineElement
//     className="vertical-timeline-element--work"
//     contentStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
//     contentArrowStyle={{ borderRight: '7px solid  rgb(90, 150, 243)' }}
//     date="2011 - present"
//     iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}

//   >
//     <h3 className="vertical-timeline-element-title">Software Engineer</h3>
//     <h4 className="vertical-timeline-element-subtitle">Prodapt</h4>
//     <p>
//     Migrated authentication system to AWS Cognito for 20k+ users with social login and enhanced security.
//     </p>
//     <p>
// Secured user data via encryption and dynamic masking without affecting user experience.
//     </p>
//     <p>
// Integrated Razorpay to replace manual payments, automating verification and improving user experience.
//     </p>
//   </VerticalTimelineElement>
//   <VerticalTimelineElement
//     className="vertical-timeline-element--work"
//     date="Jul 2023 - Dec 2023"
//     iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Software Engineer Trainee</h3>
//     <h4 className="vertical-timeline-element-subtitle">Prodapt</h4>
//     <p>
//     Built responsive React UIs with role-based post-login views for admins and users, ensuring smooth frontend-backend interaction.
// </p>
// <p>
// Migrated to microservices, improving efficiency by 40% and reducing downtime by 35%.
// </p>
// <p>
// Automated account suspension and invoice generation, cutting manual work by 25%.
//     </p>
//   </VerticalTimelineElement>
//   <VerticalTimelineElement
//     className="vertical-timeline-element--work"
//     date="Aug 20019 - May 2023"
//     iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Electronics & Communication Engineeringr</h3>
//     <h4 className="vertical-timeline-element-subtitle">Silicon Institute of Technology</h4>
//     <p>
//       User Experience, Visual Design
//     </p>
//   </VerticalTimelineElement>
//   {/* <VerticalTimelineElement
//     className="vertical-timeline-element--work"
//     date="2006 - 2008"
//     iconStyle={{ background: 'rgb(33, 150, 243)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Web Designer</h3>
//     <h4 className="vertical-timeline-element-subtitle">San Francisco, CA</h4>
//     <p>
//       User Experience, Visual Design
//     </p>
//   </VerticalTimelineElement>
//   <VerticalTimelineElement
//     className="vertical-timeline-element--education"
//     date="April 2013"
//     iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Content Marketing for Web, Mobile and Social Media</h3>
//     <h4 className="vertical-timeline-element-subtitle">Online Course</h4>
//     <p>
//       Strategy, Social Media
//     </p>
//   </VerticalTimelineElement>
//   <VerticalTimelineElement
//     className="vertical-timeline-element--education"
//     date="November 2012"
//     iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Agile Development Scrum Master</h3>
//     <h4 className="vertical-timeline-element-subtitle">Certification</h4>
//     <p>
//       Creative Direction, User Experience, Visual Design
//     </p>
//   </VerticalTimelineElement> */}
//   {/* <VerticalTimelineElement
//     className="vertical-timeline-element--education"
//     date="2002 - 2006"
//     iconStyle={{ background: 'rgb(233, 30, 99)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   >
//     <h3 className="vertical-timeline-element-title">Bachelor of Science in Interactive Digital Media Visual Imaging</h3>
//     <h4 className="vertical-timeline-element-subtitle">Bachelor Degree</h4>
//     <p>
//       Creative Direction, Visual Design
//     </p>
//   </VerticalTimelineElement> */}
//   <VerticalTimelineElement
//     iconStyle={{ background: 'rgb(16, 204, 82)', color: '#fff' }}
//     icon={<img src={WorkIcon} alt="Work Icon" style={{ width: "100%", height: "100%", borderRadius: "50%" }} />}
//   />
// </VerticalTimeline>
//     </div>
//   )
// }

// export default ReactiveTimeline
